/*
	jquery.Directory

	Copyright (c) 2014 John David Parsons
	Licensed under the MIT, GPL licenses.

	Loads a directory feed from www.elon.edu/directory/xml.ashx
	
	$(document).ready(function(){
		$('.directory').Directory();
	});
*/

(function($) {
	$(document).ready(function(){
		$('.directory-feed').Directory();
	});
	$.fn.Directory = function(opts) {
		opts = $.extend({}, $.fn.Directory.options, opts);
		
		this.each(function() {
			var el = $(this);
			
			el.empty();
			el.append('<div class="directory-loader"><i class="fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true"></i><span class="sr-only">Loading directory feed</span></div>');
			
			var source = el.data('source') || 'https://www.elon.edu/Directories/xml.ashx?full=true&type=json'; // the data-source attribute can either be an element ID (a jquery selector) that will get the text contents of that element, or a url that points to a web api. If it is blank, the default directory api url is used.
			
			var isLocal = source[0] === '#'; // if it's first character is #, it must be a jQuery selector to the data source's ID
			
			// show/hide different parts of the feed data
			var showBio = el.attr('data-bio') === 'true';
			var showPhoto = el.attr('data-photo') === 'true'; // don't output the whole link if photo is hidden, also remove all classes on the text column
			var showContact = el.attr('data-contact') === 'true'; // deprecated but leaving in for backwards compatibility
			var showPhone = el.attr('data-phone') === 'true';
			var showEmail = el.attr('data-email') === 'true';
			var showAddress = el.attr('data-address') === 'true'; // deprecated but leaving in for backwards compatibility
			var showOffice = el.attr('data-office') === 'true';
			var showCampusBox = el.attr('data-campusbox') === 'true';
			var showExpertise = el.attr('data-expertise') === 'true'; // this includes the one-line expertise field
			var gridLayout = el.attr('data-grid') || '';
			var noLinks = el.attr('data-nolinks') === 'true'; // this prevents any links from being rendered. This is used when the webpage is going to appear on a digital sign, to prevent users from clicking away from the content intended to be displayed on the sign.

			if (isLocal) {
			
				source = $.parseJSON($.trim($(source).text())); // this converts source from a jQuery selector, to a JSON object
			} else { // otherwise it must be a URL
				// build source query vars
				
				// list of directory IDs (the options are managed by HR in the MasterList database)
				if (el.attr('data-departments')) {
					source += '&departments=' + el.attr('data-departments');
				}
				
				// a list of usernames to exclude
				if (el.attr('data-exclude')) {
					source += '&exclude=' + el.attr('data-exclude');
				}
				
				// a list of usernames to append
				if (el.attr('data-individuals')) {
					source += '&individuals=' + el.attr('data-individuals');
				}
				
				// a list of usernames that will be stickied to the top of the list
				if (el.attr('data-featured')) {
					source += '&featured=' + el.attr('data-featured');
				}
				
				// a list of building IDs (managed by HR in MasterList database)
				if (el.attr('data-buildingIds')) {
					source += '&buildingIds=' + el.attr('data-buildingIds');
				}
				
				// a partial name query (ex: q=smith) will return all Employees that contain Smith in their first or last name
				if (el.attr('data-q')) {
					source += '&q=' + el.attr('data-q');
				}
				
				// if data-searchtype="keyword" then the q=... var will also search the directory profiles as well as searching by name
				if (el.attr('data-searchtype')) {
					source += '&searchtype=' + el.attr('data-searchtype');
				}
				
				var profileUrl = 'https://www.elon.edu/u/directory/profile/';
				
				if (typeof theme_opts !== 'undefined' && theme_opts.directory_profile_url != '') {
					profileUrl = theme_opts.directory_profile_url;
				}
				
				if (el.attr('data-profileurl')) {
					profileUrl = el.attr('data-profileurl');
				}
				
			}

			var deferred = $.fn.Directory.getData(source, isLocal);
			
			deferred.done(function(data){
				var ul = $.fn.Directory.getList(data, showBio, showPhoto, showAddress, showOffice, showCampusBox, showContact, showPhone, showEmail, showExpertise, gridLayout, profileUrl);
				
				if (el.attr('data-delay')) { // delays the display, for testing the loading spinner, to make testing the css easier
					setTimeout(function(){
						el.empty();
						el.append(ul);
						
						if (gridLayout !== '') {
							$(gridLayout.split(' ')).each(function(i, val){
								el.addClass(val);
							});
						}
						
						if (noLinks === true) {
							$('a', el).contents().unwrap();
						}
						
					}, parseInt(el.attr('data-delay')));
				} else {
					el.empty();
					el.append(ul);
					
					if (gridLayout !== '') {
						$(gridLayout.split(' ')).each(function(i, val){
							el.addClass(val);
						});
					}
					
					if (noLinks === true) {
						$('a', el).contents().unwrap();
					}
					
				}
			});
			
			
		});
		
		return this;
	};
	
	$.fn.Directory.getList = function(data, showBio, showPhoto, showAddress, showOffice, showCampusBox, showContact, showPhone, showEmail, showExpertise, gridLayout, profileUrl) {
		if (!data || data.length <= 0) {
			return $('<ul><li>no results</li></ul>');
		}
		
		var employees = data.ArrayOfJoinedEmployeeInfo.JoinedEmployeeInfo;
		
		var ul = $('<ul class="directory-list"></ul>');
		
		for(var i = 0; i < employees.length; i++) {
			var li = $.fn.Directory.getListItem(employees[i], showBio, showPhoto, showAddress, showOffice, showCampusBox, showContact, showPhone, showEmail, showExpertise, gridLayout, profileUrl);
			ul.append(li);
		}
		
		return ul;
	};
	
	$.fn.Directory.getListItem = function(employee, showBio, showPhoto, showAddress, showOffice, showCampusBox, showContact, showPhone, showEmail, showExpertise, gridLayout, profileUrl) {
		
		var profile;
		
		if (employee.Profile) {
			profile = employee.Profile[0];
		}
		var e = employee.Employee[0];
		
		var li = $('<li class="directory-item"></li>');
		
		var photoUrl = 'https://www.elon.edu/PhotoManager/GetImage.ashx?user=' + e.Username + '&crop=5:7&w=300';
		var name = $.fn.Directory.getFullName(e);
		var position = e.Position;
		var phone = e.Phone;
		var email = e.EmailAddress;
		var office = e.BuildingName + ' ' + e.Office;
		var address = e.CampusBox + ' Campus Box<br> Elon, NC 27244';
		
		if (showPhoto === true) {		
			var directoryImg = $('<div class="directory-item--img-wrap"><a class="directory-item--img-link" href="' + profileUrl + '?user=' + e.Username + '" aria-hidden="true" tabindex="-1"><img class="directory-item--img" src="' + photoUrl + '" alt="Headshot of ' + name + '"></a></div>');
			
			li.append(directoryImg);
		}
		
		var wrap = $('<div class="directory-item--info"></div>');
		
		wrap.append('<p class="directory-name"><a href="' + profileUrl + '?user=' + e.Username + '">' + name + '</a></p>');
		wrap.append('<p class="directory-position">' + position + '</p>');
		
		// showAddress is now deprecated and we show/hide office and campus box separately
		// keeping this rule in for legacy feeds that still have the data-address="true" attribute to make the new options backwards compatible
		if (showAddress === true) {
			wrap.append('<p class="directory-office">' + office + '</p>');
			wrap.append('<p class="directory-address">' + address + '</p>');
		}
		
		if (office && showOffice === true) {
			wrap.append('<p class="directory-office">' + office + '</p>');
		}
		
		if (address && showCampusBox === true) {
			wrap.append('<p class="directory-address">' + address + '</p>');
		}
		
		// showContact is now deprecated and we show/hide phone and email separately
		// keeping this rule in for legacy feeds that still have the data-contact="true" attribute to make the new options backwards compatible
		if (showContact === true) {
			wrap.append('<p class="directory-phone"><a href="tel:' + phone + '">' + phone + '</a></p>');
			wrap.append('<p class="directory-email"><a href="mailto:' + email + '">' + email + '</a></p>');
		}
		
		if (phone && showPhone === true) {
			wrap.append('<p class="directory-phone"><a href="tel:' + phone + '">' + phone + '</a></p>');
		}
		
		if (email && showEmail === true) {
			wrap.append('<p class="directory-email"><a href="mailto:' + email + '">' + email + '</a></p>');
		}
		
		var expertise = '';
		var briefBio = '';
		
		// if a profile exists, then add all of the profile-specific values, like OneLineExpertise and BriefBiography
		if (profile) {
			expertise = profile.OneLineExpertise;
			briefBio = profile.BriefBiography;
			
			if (expertise && $.trim(expertise) !== '' && showExpertise === true) {
				wrap.append('<p class="directory-expertise">' + expertise + '</p>');
			}
			
			if (showBio === true && briefBio && $.trim(briefBio) !== '') {
				
				if (briefBio.indexOf('<p') > -1) { // if it's a multi-paragraph brief bio, wrap it in a <div class="directory-bio">
					wrap.append('<div class="directory-bio">' + briefBio + '</div>');
				} else {
					wrap.append('<p class="directory-bio">' + briefBio + '</p>');
				}
			}
		}
		
		li.append(wrap);
		
		return li;
	};
	
	// gets the full Employee name, using nickname instead of first name if available. Also appends suffix if present.
	$.fn.Directory.getFullName = function(e) {
		var nickname = $.trim(e.NickName);
		
		// sometimes NickName is surrounded by single quotes in the database, so remove them if present. Some names have single quotes in the middle of the name, so they shouldn't be removed
		if (nickname.indexOf("'") === 0) {
			nickname = nickname.substring(1, nickname.length);
		}
		
		if (nickname.indexOf("'") == nickname.length - 1) {
			nickname = nickname.substring(0, nickname.length - 1);
		}
		
		var firstname = $.trim(e.FirstName);
		var lastname = $.trim(e.LastName);
		
		var firstOrNickname = nickname === '' ? firstname : nickname;
		
		if (e.Suffix !== '') {
			lastname += ' ' + e.Suffix;
		}
		
		return firstOrNickname + ' ' + lastname;
	};
	
	// pass in a URL or XML string, and get a deferred object back. If an xml string is passed, the deferred object is immediately resolved. This allows for local unit testing, without having to branch anything that depends on an xml file into asynch and synch methods.
	$.fn.Directory.getData = function(source, isLocal) {
		
		if (isLocal) { // if it's a local source, element ID
			var deferred = $.Deferred();
			deferred.resolve(source); // immediately resolve the deferred because all of the data is local and pre-loaded
			return deferred;
		} else { // otherwise, it's a web api URL
			return $.getJSON(source);
		}
	};
	
	$.fn.Directory.options = {
		test: 'jd'
	};
	
}(jQuery));



/**
* This is a temporary fix for the directory feed image loading issue. 
* We are going to hide the directory feed and replace it with a spinner on document ready. 
* Once the window has loaded we will then display the directory feed.
*/
(function($){
	$(document).ready(function(){
		directoryFix();	
	});
	
	function directoryFix(){
		var directoryFeed = $('.directory-feed');
		$('.directory-feed').after('<div class="directory-loader"><i class="fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true"></i><span class="sr-only">Loading directory feed</span></div>');
		if(directoryFeed !== null){
			directoryFeed.hide();
			$(window).load(function(){
				directoryFeed.show();
				$('.directory-loader').hide();
			});
		}
	}
}(jQuery));